"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveComponent = exports.isDownloadedComponent = exports.getComponent = void 0;
var _withModalAPI = _interopRequireDefault(require("./withModalAPI"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache = {};
var isDownloadedComponent = exports.isDownloadedComponent = function isDownloadedComponent(key) {
  return Boolean(cache[key]);
};
var getComponent = exports.getComponent = function getComponent(key) {
  return cache[key];
};
var saveComponent = exports.saveComponent = function saveComponent(key, Component) {
  cache[key] = (0, _withModalAPI.default)(Component);
};